import React, { useContext } from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import Row from '../../layout/Row';
import { userRoles } from '../../RoleProtected';
import { UserContexts } from '../../stateProvider/UsersContext';
import ModalFactory from '../../Modal';
import Checkbox from '../../forms/Checkbox';
import GetState from '../../GetState';
import AutoSelectAndUpgrade from '../../forms/formComponents/AutoSelectAndUpgrade';

const WashClubSettings = ({ ...props }) => {
    const context = useContext(UserContexts);

    const [usersWCSettings, refreshWCSettings] = GetState(QuestRoute.user.washClubSettings(context.user.customerId));

    const resetUserWCSettings = (user) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: (<span>Are you sure you want to restore Wash Club default settings for {context.user.firstName}?</span>),
                type: 'warning',
            },
            promise: {
                title: 'Restoring Defaults',
                body: `Restoring, please wait.`,
                callback: () => HamQuest.delete(QuestRoute.user.washClubSettings(context.user.customerId))
            },
            confirmed: {
                title: 'Success',
                body: `${context.user.firstName}'s settings have been set to default.`,
                type: 'success'
            },
            finally: () => refreshWCSettings()
        })
    }

    return (
        <FormSetting
            name='washClubUserSettings'
            label={`User's Wash Club Settings`}
            onSubmit={e => {
                if (e.allowUpgrades == true || e.allowUpgrades == false)
                    e.allowUpgrades = e.allowUpgrades.toString().charAt(0).toUpperCase() + e.allowUpgrades.toString().slice(1).toLowerCase();
                if (e.autoSelect == true || e.autoSelect == false)
                    e.autoSelect = e.autoSelect.toString().charAt(0).toUpperCase() + e.autoSelect.toString().slice(1).toLowerCase();
                console.log(e)
                return HamQuest.put(QuestRoute.user.washClubSettings(context.user.customerId), { ...e }).then(() => refreshWCSettings())
            }}
            inputs={{ ...usersWCSettings }}
            controls={[<Button label='Restore Default Settings' onClick={resetUserWCSettings} />]}
            roles={userRoles.editCustomers}
            text='Update'
            editable
        >
            {/* todo: Is 'editing' the approriate flag to determine when the form is in edit mode?
                      It's value is opposite of what you would expect. 
                      
                todo: Extract Max Use Period and PassMaxUses into a separate component. Use for Pass Max Uses, 
                      App Scan Max Uses, and App Scan Max Timer Uses*/}
            {({ values, editing }) => (
                <>
                    <Row wrap>
                        <Select
                            label='Max Use Period'
                            name='passMaxUsePeriod'
                            options={HSOptions.washClub.period}
                            required
                        />
                        {(values.passMaxUsePeriod === 'Unlimited' || values.passMaxUsePeriod === 'UseDefault') ? (
                            <Input
                                label='Pass Max Uses'
                                disabled
                                required
                            />
                        ) : (
                        <Input
                            label='Pass Max Uses'
                            name='passMaxUses'
                            type='number'
                            min={1}
                            disabled = {values.passMaxUsePeriod === 'Unlimited' || values.passMaxUsePeriod === 'UseDefault' || editing}
                            required
                        />
                        )}
                    </Row>

                    <Row wrap>
                        <Select
                            label='App Scan Max Use Period'
                            name='appIdPassMaxUsePeriod'
                            options={HSOptions.washClub.period}
                            required
                        />
                         {(values.appIdPassMaxUsePeriod === 'Unlimited' || values.appIdPassMaxUsePeriod === 'UseDefault') ? (
                            <Input
                                label='App Scan Max Uses'
                                disabled
                                required
                            />
                        ) : (
                            <Input
                                label='App Scan Max Uses'
                                name='appIdPassMaxUses'
                                type='number'
                                min={1}
                                disabled = {values.appIdPassMaxUsePeriod === 'Unlimited' || values.appIdPassMaxUsePeriod === 'UseDefault' || editing}
                                required
                        />)}
                    </Row>

                    <Row wrap>
                        <Select
                            label='App Scan Max Timer Use Period'
                            name='appIdPassMaxTimerUsePeriod'
                            options={HSOptions.washClub.period}
                            required
                         />
                        {(values.appIdPassMaxTimerUsePeriod === 'Unlimited' || values.appIdPassMaxTimerUsePeriod === 'UseDefault') ? (
                            <Input
                                label='App Scan Max Timer Uses'
                                disabled
                                required
                            />
                        ) : (
                            <Input
                                label='App Scan Max Timer Uses'
                                name='appIdPassMaxTimerUses'
                                type='number'
                                min={1}
                                disabled = {values.appIdPassMaxTimerUsePeriod === 'Unlimited' || values.appIdPassMaxTimerUsePeriod === 'UseDefault' || editing}
                                required
                            />)}
                    </Row>

                    <Row align='flex-end' wrap>
                        <Checkbox
                            label='Use Default Pass Reuse Time'
                            name='useDefaultPassReuseTime'
                        />
                        {values.useDefaultPassReuseTime ? 
                            <Input
                                label='Pass Reuse Inhibit Time (min)'
                                disabled
                                required
                            /> :
                            <Input
                                label='Pass Reuse Inhibit Time (min)'
                                name='passReuseInhibitTime'
                                type='number'
                                disabled={values.useDefaultPassReuseTime || editing}
                                required
                            />
                        }
                    </Row>

                    <AutoSelectAndUpgrade
                        upgrades='allowUpgrades'
                        select='autoSelect'
                        values={values}
                    />

                    <Row align='flex-end' wrap>
                        {/* <Checkbox
                            label='Email Invoice Receipt'
                            name='emailInvoiceReceipt'
                        /> */}
                        <Select
                            label='Kiosk Receipt Mode'
                            name='receiptMode'
                            options={HSOptions.washClub.receiptMode}
                            required
                        />
                    </Row>

                </>
            )}
        </FormSetting>
    );
}

export default WashClubSettings;
